import styled from 'styled-components';

export const Container = styled.div`
   > .ant-divider-horizontal.ant-divider-with-text-left{
        color: rgb(82,82,113);
   }
   > .ant-divider-horizontal.ant-divider-with-text-left::before {
        border-top: 1px solid #dedddd;
   }
   > .ant-divider-horizontal.ant-divider-with-text-left::after {
        border-top: 1px solid #dedddd;
    }
}`;

export const ComponentsArea = styled.div`
    height: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
    justify-items: center;
    grid-template-rows: 74px;
}
`;
